import "./Banner.scss"
import classnames from "classnames"
import React from "react"
import Icon from "./Icon"

const Banner = ({ title, children, frown, className }) => {
  return (
    <div className={classnames("Banner", className)}>
      <Icon type="fill" name={frown ? "frownie" : "smiley"} size={80} />
      <div className="Banner_info">
        <h2 className="Banner_title">{title}</h2>
        <p className="Banner_copy">{children}</p>
      </div>
    </div>
  )
}

Banner.displayName = "Banner"

export default Banner



// WEBPACK FOOTER //
// ./src/lib/Banner.js